import { styled } from '@/stitches.config';
import { slugify } from '@/utils/slugify';
import { ButtonText } from '@/components/button-text/button-text';
import { WorkSubsection } from '@/lib/schemas/work-subsection';

type Props = {
  subsections?: Array<WorkSubsection>;
};

export function DesktopNestedNavigation({ subsections }: Props) {
  return (
    <RowWrapper>
      <ColumnWrapper>
        {subsections &&
          subsections.map((subsection) => {
            const slug = slugify(subsection.subcategory.name);

            return (
              <ButtonText
                href={'#' + slug}
                label={subsection.subcategory.name}
                key={subsection._key}
                type="arrow"
                onClick={(e) => {
                  e.preventDefault();

                  const el = document.getElementById(slug);
                  if (el) {
                    window.scrollTo({
                      top: el.offsetTop - 100,
                      behavior: 'smooth',
                    });
                  }
                }}
              />
            );
          })}
      </ColumnWrapper>
    </RowWrapper>
  );
}

const RowWrapper = styled('div', {
  display: 'none', // For mobile viewports we're simply hiding this component for the alpha release
  my: '$4',
  gridColumn: '7 / span 10',
  gap: '$4',

  '@bp4': {
    display: 'block',
    gridColumn: '7 / span 10',
  },

  '@bp5': {
    gridColumn: '6 / span 11',
  },
});

const ColumnWrapper = styled('div', {
  gap: '$1 $7',

  '@bp4': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(auto, max-content))',
  },
});
